<template>
  <div :class="['scope-section', 'scope-container', { ['referral-scope']: autoCampaignType === 16 }]" :id="`scope-index-${scopeIndex}`">
    <div v-if="priorityErrors" class="error-label">{{priorityErrors}}</div>

    <div v-if="topApiErrors.length" class="error-alert"><p v-for="error in topApiErrors">{{error}}</p></div>

    <div class="scope-header">
      <div v-if="audiences > 1" :class="['header-priority', { error: priorityErrors }]">
        <div :class="['flaticon-arrows-2', { disabled: scope.priority === 1 }]" @click="changePriority(-1)"></div>
        <div class="priority">{{scope.priority}}</div>
        <div :class="['flaticon-arrows-1', { disabled: scope.priority === totalScopes }]" @click="changePriority(1)"></div>
      </div>
      <div class="header-audience">audience id: #{{scope.id}}</div>
      <div v-if="audiences > 1" class="header-delete" @click="showDeleteWarning('audience')">delete</div>
    </div>

    <div v-if="isBudzAutoCampaign" class="referral-notice">person who refers will receive:</div>

    <group-widget
        :campaignId="scope.id"
        campaignType="AutoCampaignScope"
        :hideCarriersGroup="merchantCountryIsCanada"
        :openGroupItem="openGroupItem"
        :scopeMerchantTagIds="scope.merchant_tag_ids"
        :scopeSelectedSegmentIds="scope.merchant_segment_ids"
        :scopeSelectedGroups="scope.groups_with_selected"
        :scopeUpdating="scopeUpdating"
        @updateData="updateData"
        @updateScope="updateScope">
    </group-widget>

    <div v-if="apiErrors['loadMessages']" class="error-alert">{{apiErrors['loadMessages']}}</div>

    <message-edit
      v-for="message in messages"
      :activeMessage="selectedMessage === message.id"
      :autoCampaignId="autoCampaignId"
      :isBudzAutoCampaign="isBudzAutoCampaign"
      :key="message.id"
      :messageFromScope="message"
      :messageModuleName="`message-${message.id}`"
      :messageId="message.id"
      :sendTime="sendTime"
      @updateEmptyMessage="updateEmptyMessage"
      class="message-edit">
    </message-edit>

    <!-- Commenting this out instead of deleting this as well related code because the plan is to add this functionality back in in the future.
    <div :class="['message-tabs', {['one-message']: messages.length === 1}]">
      <div v-for="(message, index) in messages"
           :class="['tab', {selected: selectedMessage === message.id, empty: emptyMessages.includes(message.id)}]"
           @click="selectMessage(message.id)">
        <a class="message-index">{{index + 1}}</a>
        <div v-if="messages.length > 1 && selectedMessage === message.id" class="delete-message-tab" @click="showDeleteWarning('message')">×</div>
      </div>

      <div class="add-message-section" v-if="allowMultiMessages">
        <a v-if="messages.length > 1" class="add-message" @click.stop="createMessage">+</a>
        <a v-else class="add-message" @click.stop="createMessage">+ message</a>
      </div>
    </div> -->
    <div v-if="bottomApiErrors.length" class="error-alert"><p v-for="error in bottomApiErrors">{{error}}</p></div>

    <div v-if="isBudzAutoCampaign" class="referral-message">
      <div class="referral-notice">customer joining via referral will receive:</div>
      <message-edit
          v-for="(message, index) in messageReferred"
          activeMessage
          :autoCampaignId="autoCampaignId"
          :isBudzAutoCampaign="isBudzAutoCampaign"
          :key="message.id"
          :messageFromScope="message"
          :messageModuleName="`message-${message.id}`"
          :messageId="message.id"
          :messageIndex="index"
          :messagePriority="message.priority"
          :sendTime="sendTime"
          @updateEmptyMessage="updateEmptyMessage">
      </message-edit>
    </div>

  <transition name="fade" @after-enter="afterEnterModal">
    <modal
        v-if="showModal"
        :isWarningModal="modalConfig.isWarningModal"
        showClose
        :wrapperClasses="modalConfig.wrapperClasses"
        :warningProceedText="modalConfig.warningProceedText"
        @close="closeModal"
        @action="modalConfig.actionFunction"
        @proceed="modalConfig.proceedFunction">
      <h3 slot="header" class="modal-title">{{modalConfig.title}}</h3>

      <div slot="body" :class="modalConfig.bodyClasses">
        <p>{{modalConfig.content}}</p>
      </div>

      <div
          v-if="modalConfig.actionButton"
          slot="action"
          class="send-mms-campaign button larger modal-click-action"
          @click="modalConfig.actionFunction">
        {{modalConfig.actionButton}}
      </div>
    </modal>
  </transition>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import MessageEdit from './MessageEdit'
  import GroupWidget from '../GroupWidget/'
  import { mapGetters } from 'vuex'
  import Modal from '../shared/Modal'
  import ModalMixin from '../../mixins/ModalMixin'

  export default {
    props: {
      allowMultiMessages: Boolean,
      audiences: Number,
      autoCampaignId: String,
      autoCampaignType: Number,
      neverSend: Boolean,
      scope: Object,
      scopeIndex: Number,
      sendTime: String,
      shouldChangePriority: Boolean,
      totalScopes: Number,
    },

    name: 'Scope',

    components: {
      GroupWidget,
      MessageEdit,
      Modal,
    },

    mixins: [AxiosMixin, ModalMixin],

    data() {
      return {
        apiErrors: {},
        emptyMessages: [],
        messages: [],
        messageReferred: [],
        openGroupItem: null,
        scopeUpdating: false,
        selectedMessage: null,
      }
    },

    methods: {
      afterChangePriority(data, apiError) {
        const hasSuccess = data && data.success
        this.endpointUpdate(hasSuccess, apiError)
      },

      afterCreateMessage(data, apiError) {
        const messageId = data && data.message_id ? data.message_id : null
        if (messageId) {
          this.selectedMessage = messageId
          this.loadMessages()
        }
        this.updateApiErrors(apiError, !!messageId)
      },

      afterDeleteMessage(data, apiError) {
        const hasSuccess = data && data.success
        if (hasSuccess) {
          this.removeErrorsInteractions([`extensions${this.selectedMessage}`,`offers${this.selectedMessage}`, `sms${this.selectedMessage}`])
          this.loadMessages()
        }
        this.updateApiErrors(apiError, hasSuccess)
      },

      afterDeleteScope(data, apiError) {
        const hasSuccess = data && data.success
        hasSuccess && this.messages.map(m => m.id).forEach((id) => {
          let scopeId = apiError ? apiError.scopeId : false
          scopeId && this.removeErrorsInteractions([`extensions${id}`, `offers${id}`, `scope${scopeId}}`, `sms${id}`])
        })
        this.endpointUpdate(hasSuccess, apiError)
      },

      afterLoadMessages(data, apiError) {
        const isValidData = Array.isArray(data),
          selectedId = this.selectedMessage
        if (isValidData) {
          this.messages = data.filter(message => message.priority === null)
          this.messageReferred = data.filter(message => message.priority === -1)
          this.selectedMessage = this.messages.map(message => message.id).includes(selectedId) ? selectedId : this.messages[0].id
        }
        this.updateApiErrors(apiError, isValidData)
      },

      afterUpdateScope(data, apiError) {
        const scopeData = data ? data.auto_campaign_scope : null
        this.endpointUpdate(scopeData, apiError)
      },

      buildApiErrors(apiErrors, errorTypes) {
        const hasErrors = !!Object.keys(apiErrors).length
        let errors = []
        hasErrors && errorTypes.forEach((errorKey) => apiErrors[errorKey] && errors.push(apiErrors[errorKey]))
        return errors
      },

      changePriority(priority) {
        const canChange = priority === -1 ? this.scope.priority !== 1 : this.scope.priority !== this.audiences
        if (canChange) {
          const url = `/api/v3/auto_campaign_scopes/${this.scope.id}/scope_priority?auto_campaign_id=${this.autoCampaignId}`,
            methodType = 'post',
            params = { priority: priority }
          let onExtraParam = { type: 'changePriority', message: 'issue changing the priority for this audience' }
          this.axiosMethod({methodType, url, params, onSuccess: this.afterChangePriority, onError: this.endpointErrors, onExtraParam})
        }
      },

      createMessage() {
        const url = `/api/v3/auto_campaign_scopes/${this.scope.id}/create_message?auto_campaign_id=${this.autoCampaignId}`,
          methodType = 'post'
        let onExtraParam = { type: 'createMessage', message: 'issue adding a new message' }
        this.axiosMethod({methodType, url, onSuccess: this.afterCreateMessage, onError: this.endpointErrors, onExtraParam})
      },

      deleteMessage() {
        this.showModal = false
        const url = `/api/v3/auto_campaign_messages/${this.selectedMessage}?auto_campaign_id=${this.autoCampaignId}`,
          methodType = 'delete'
        let onExtraParam = { type: 'deleteMessage', message: 'issue deleting the message' }
        this.axiosMethod({methodType, url, onSuccess: this.afterDeleteMessage, onError: this.endpointErrors, onExtraParam})
      },

      deleteScope() {
        const scopeId = this.scope.id,
          url = `/api/v3/auto_campaign_scopes/${scopeId}?auto_campaign_id=${this.autoCampaignId}`,
          methodType = 'delete'
        let onExtraParam = { type: 'deleteScope', message: 'issue deleting the audience', scopeId }
        this.axiosMethod({methodType, url, onSuccess: this.afterDeleteScope, onError: this.endpointErrors, onExtraParam})
      },

      endpointErrors(error, apiError) {
        apiError.message = `${apiError.message}. ${error}`
        this.updateApiErrors(apiError)
        if (apiError && apiError.loadingType) { this[apiError.loadingType] = false }
      },

      endpointUpdate(data, apiError) {
        data && this.$emit('loadAllScopes')
        this.updateApiErrors(apiError, !!data)
        if (apiError && apiError.loadingType) { this[apiError.loadingType] = false }
      },

      loadMessages() {
        const url = `/api/v3/auto_campaign_messages/?scope_id=${this.scope.id}&auto_campaign_id=${this.autoCampaignId}`
        let onExtraParam = { type: 'loadMessages', message: 'issue loading messages for this audience' }
        this.axiosMethod({url, onSuccess: this.afterLoadMessages, onError: this.endpointErrors, onExtraParam})
      },

      removeErrorsInteractions(errorKeys) {
        errorKeys.forEach((key) => {
          this.$store.dispatch('UPDATE_STATE_OBJECT', {itemKey: key, itemObject: {} })
          this.$store.dispatch('UPDATE_STATE_OBJECT', {
            stateKey: 'noUserInteractions',
            itemKey: key,
            itemObject: {}
          })
        })
      },

      selectMessage(messageId) {
        this.selectedMessage = messageId
      },

      showDeleteWarning(type) {
        const isScopeType = type === 'audience'
        this.modalConfig = {
          actionFunction: isScopeType ? this.deleteScope : this.deleteMessage,
          bodyClasses: 'delete-warning',
          content: `are you sure you want to delete this ${type} and all of its history?`,
          isWarningModal: true,
          proceedFunction: isScopeType ? this.deleteScope : this.deleteMessage,
          title: `delete this autoconnect ${type}`,
          warningProceedText: `delete ${type}`,
          wrapperClasses: 'confirm-delete'
        },
        this.showModal = true
      },

      updateApiErrors(error, shouldRemove) {
        const errorExists = this.apiErrors[error.type]
        if (shouldRemove) {
          if (errorExists) { this.$delete(this.apiErrors, error.type, error.message) }
        } else {
          if (!errorExists) { this.$set(this.apiErrors, error.type, error.message) }
        }
      },

      updateEmptyMessage(selectedMessageId, isEmpty) {
        let idsToUpdate = this.emptyMessages
        const alreadyAdded = idsToUpdate.includes(selectedMessageId)
        if (isEmpty) {
          if (!alreadyAdded) { idsToUpdate.push(selectedMessageId) }
          return this.emptyMessages = idsToUpdate
        } else {
          idsToUpdate = this.emptyMessages.filter((id) => id !== selectedMessageId)
          return this.emptyMessages = idsToUpdate
        }
      },

      updateData(field, value) {
        this[field] = value
      },

      updateScope(dataToUpdate) {
        this.scopeUpdating = true
        let apiError = { type: 'updateScope', loadingType: 'scopeUpdating', message: 'issue updating the audience' }
        const url = `/api/v3/auto_campaign_scopes/${this.scope.id}?auto_campaign_id=${this.autoCampaignId}`,
          params = { auto_campaign_scope: dataToUpdate },
          methodType = 'patch'
        this.axiosMethod({methodType, url, params, onSuccess: this.afterUpdateScope, onError: this.endpointErrors, onExtraParam: apiError})
      },
    },

    created() {
      this.loadMessages()
    },

    computed: {
      bottomApiErrors: function () {
        const apiErrors = this.apiErrors,
          errorTypes = ['createMessage', 'deleteMessage']
        return this.buildApiErrors(apiErrors, errorTypes)
      },

      isBudzAutoCampaign: function() {
        return this.autoCampaignType === 16
      },

      priorityErrors: function () {
        if (this.neverSend) {
          const filteredMessage = 'this filtered audience will never send. change the priority to above an unfiltered audience',
            noFilteredMessage = 'only one unfiltered audience will send. change the priority or add more messages to the other unfiltered audience'
          return this.scope.is_filtered ? filteredMessage : noFilteredMessage
        } else if (this.shouldChangePriority) {
          return 'this audience should be the last priority as it blocks other audiences from sending'
        }
      },

      topApiErrors: function () {
        const apiErrors = this.apiErrors,
          errorTypes = ['changePriority', 'deleteScope', 'updateScope']
        return this.buildApiErrors(apiErrors, errorTypes)
      },

      ...mapGetters(['merchantCountryIsCanada']),
    },
  }
</script>

<style>
  .message-edit {
    margin-top: 20px;
  }
</style>
